export default __webpack_public_path__ + "static/media/Snd_4_Starts.c6e0238d.mp3";